// Chakra imports
import { Flex, useColorModeValue } from '@chakra-ui/react';

// Custom components
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
  //   Chakra color mode
  const logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column">
      <p style={{ fontSize: '28px', margin: '2% ', color: logoColor }}>
        Raee Back Office
      </p>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
